export const getAllChildrenTags = (tag) => {
  const results = [];
  const queue = [...(tag.children || [])];

  while (queue.length) {
    const currentTag = queue.shift();
    results.push(currentTag);
    queue.push(...(currentTag.children || []));
  }

  return results;
};
